module.exports = __webpack_public_path__ + "img/huiYuan.432ab3e3.png";